import { OnInit, EventEmitter, InjectionToken } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponentComponent } from '../base-component/base-component.component';
import { FiltersTypeEnum } from '../../filters/filters.enum';
import { filter, tap, first, delay, debounceTime, map } from 'rxjs/operators';
import { TranslocoService } from '@ngneat/transloco';
import { of } from 'rxjs';
import * as i0 from "@angular/core";
export const TYPE_FILTER_TOKEN = new InjectionToken('type-filter');
/**
 * Class for provide some common interface to all filters component.
 *
 * @export
 * @class RouterFilterReference
 */
export class RouterFilterReference extends BaseComponentComponent {
    constructor(type) {
        super();
        this.type = type;
        this.changeData = new EventEmitter();
    }
}
RouterFilterReference.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function RouterFilterReference_Factory() { return new RouterFilterReference(i0.ɵɵinject(TYPE_FILTER_TOKEN)); }, token: RouterFilterReference, providedIn: "root" });
/**
 *
 *
 * @export
 * @class FiltersRouterDirective
 * @implements {OnInit}
 */
export class FiltersRouterDirective extends BaseComponentComponent {
    constructor(host, router, route, translation_service) {
        super();
        this.host = host;
        this.router = router;
        this.route = route;
        this.translation_service = translation_service;
    }
    /**
     * Method for get the name of the query that would appear in parameter.
     *
     * @param {*} data
     * @returns
     * @memberof FiltersRouterDirective
     */
    handleLogicForFilter(data) {
        switch (this.host.type) {
            case FiltersTypeEnum.ComboBox:
                if (data instanceof Array) {
                    return data.map(value => value[this.host.option_name_property]);
                }
                return data ? data[this.host.option_name_property] : undefined;
            case FiltersTypeEnum.TextSearch:
                return data.length > 0 ? data : undefined;
            case FiltersTypeEnum.TagsFilter:
                return data && data.value ? data.value : undefined;
            case FiltersTypeEnum.DateFilter:
                const paramDate = data['value'];
                const date = new Date(paramDate.getFullYear(), paramDate.getMonth(), paramDate.getDate());
                const userTimezoneOffset = date.getTimezoneOffset() * 60000;
                return new Date(paramDate.getTime() - userTimezoneOffset).toISOString().slice(0, 10);
        }
        /*if(this.host instanceof TextFilterComponent){
          return data.length > 0 ? data : undefined;
        }*/
    }
    /**
     * Method for set the query parameter on init of component.
     *
     * @param {*} queryParameter The query parameter
     * @memberof FiltersRouterDirective
     */
    setDataInFilter(queryParameter) {
        let host;
        if (queryParameter) {
            switch (this.host.type) {
                case FiltersTypeEnum.ComboBox:
                    host = this.host;
                    this.subscriptions.push(host.options_subject.pipe(filter((value) => value.length > 0), delay(this.routerParamsData.delay_time ? this.routerParamsData.delay_time : 0), this.routerParamsData.only_on_init === true ? first() : map(a => a), tap(a => {
                        host = this.host;
                        let option;
                        if (host.allConfig.selectMultiple) {
                            const findedOptions = Array.from(a).filter(option => queryParameter.findIndex(query => query === this.translation_service.translate(option[this.host.option_name_property])) > -1);
                            option = findedOptions;
                        }
                        else {
                            option = a.find(option => this.translation_service.translate(option[this.host.option_name_property]) ===
                                queryParameter);
                        }
                        if (option) {
                            host = this.host;
                            host.options_selected_subject.next(option);
                        }
                    })).subscribe());
                    break;
                case FiltersTypeEnum.TagsFilter:
                    host = this.host;
                    const findTag = host.tags.find(value => value.value === queryParameter);
                    if (findTag && findTag.value) {
                        host.selectChange(findTag.value);
                    }
                    break;
                case FiltersTypeEnum.TextSearch:
                    host = this.host;
                    host.defaultTextValue = queryParameter;
                    host.text_subject.next(queryParameter);
                    break;
                case FiltersTypeEnum.DateFilter:
                    host = this.host;
                    //host.dateFormControl.setValue(queryParameter);
                    const auxDate = new Date();
                    const date = new Date(new Date(queryParameter).getTime() +
                        auxDate.getTimezoneOffset() * 60000);
                    host.date_subject.next({ value: date });
                    break;
            }
        }
    }
    /**
     * Method for perform navigation when the data changes and update query parameters.
     *
     * @param {*} data
     * @memberof FiltersRouterDirective
     */
    performNavigation(data) {
        if (this.routerParamsData && this.routerParamsData.intercept_name) {
            of(debounceTime(this.routerParamsData.delay_time ? this.routerParamsData.delay_time : 0)).pipe(first(), tap(a => {
                this.router.navigate([], { queryParamsHandling: 'merge',
                    //skipLocationChange:true,
                    queryParams: { [this.routerParamsData.intercept_name]: this.handleLogicForFilter(data) } });
            })).subscribe();
        }
    }
    /**
     * {@inheritdoc}
     * @memberof FiltersRouterDirective
     */
    ngAfterViewInit() {
        if (this.routerParamsData && this.routerParamsData.intercept_name) {
            this.subscriptions.push(this.route.queryParams
                .pipe(first())
                .subscribe(next => {
                this.setDataInFilter(next[this.routerParamsData.intercept_name]);
            }));
        }
    }
    /**
     * {@inheritdoc}
     *
     * @memberof FiltersRouterDirective
     */
    ngOnInit() {
        super.ngOnInit();
    }
}
